import { render } from "./DonationInfo.vue?vue&type=template&id=96f1abb6&ts=true"
import script from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DonationInfo.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/style-five/DonationInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "96f1abb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('96f1abb6', __exports__)) {
    api.reload('96f1abb6', __exports__)
  }
  
  module.hot.accept("./DonationInfo.vue?vue&type=template&id=96f1abb6&ts=true", () => {
    api.rerender('96f1abb6', render)
  })

}


export default __exports__